import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { Reservations } from 'src/app/models/reservations.model';

@Component({
    selector: 'app-reservations-token-component',
    templateUrl: './reservations-token.component.html'
})
export class ReservationsTokenComponent extends DialogContentBase implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public gridView: any[] = [];
    public formValue: Reservations = {
        id: 0,
        dataRegistoServidor: new Date(),
        refUtilizador: 0,
        refArmarioModuloCompartimento: 0,
        nomeArmario: '',
        numeroDeSerieArmario: '',
        nomeCompartimento: '',
        dataCriacao: new Date(),
        reservaUID: '',
        horasReservadas: 0,
        taxaHoraExtra: 0,
        tamanhoCacifo: '',
        validaApos: new Date(),
        validaAntes: new Date(),
        validaAte: new Date(),
        pagaAte: new Date(),
        primeiraAbertura: new Date(),
        ultimaAbertura: new Date(),
        tokens: [],
        estado: 0,
        descricaoEstado: '',
        pagamentos: [],
        dataAtualizacao: new Date(),
        horasPagas: 0,
        horasUsufruidas: 0,
        horasExtraAPagar: 0
    };
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private dialogService: DialogService, private notificationService: NotificationService, public override dialog: DialogRef, private intl: IntlService, private api: ApiService) {
        super(dialog);
        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('selecionartag');
    }

    ngOnInit(): void {
        this.setFormValues();
    }

    public placeHolder: any = {
        nome: "",
        id: undefined,
    };

    public setFormValues() {
        this.gridView = this.formValue?.tokens;
    }
}
